module.exports = __webpack_public_path__ + "img/order.4e601ca8.png";